<div class="grid grid-cols-13 grid-rows-6 h-[12vh] gap-x-5 pt-2 px-2">
  <div class="row-start-1 row-end-1 col-start-1 col-end-5">
    {{ 'Toolbar.ColorPicker'|translate }}
  </div>
  <div class="row-start-2 row-end-6 col-start-1 col-end-5 flex" >
    <app-color-picker (colorChange)="changeColor($event)" class="w-full h-full"></app-color-picker>
  </div>
  <div class="row-start-1 row-end-1 col-start-5 col-end-7 text-center">
    {{ 'Toolbar.Tool'|translate }}
  </div>

  <div class="row-start-3 row-end-5 col-start-5 col-end-7 flex justify-center">
    <p-selectbutton [options]="drawingModeOptions" [(ngModel)]="currentDrawingMode" optionValue="value"
                    (onChange)="changeDrawingMode($event.value)" size="large">
      <ng-template #item let-item>
        <i [class]="item.icon" style="font-size: 1.5rem"></i>
      </ng-template>
    </p-selectbutton>
  </div>
  <div class="row-start-1 row-end-1 col-start-7 col-end-9 text-center">
    {{ 'Toolbar.LineWidth'|translate }}
  </div>
  <div class="row-start-3 row-end-5 col-start-7 col-end-9 flex justify-around items-center">
    <i class="pi pi-minus clickable" (click)="stepLineWidth(-1)"></i>
    <p-inputnumber mode="decimal" [(ngModel)]="lineWidth" size="large" class="w-[3.3rem]" styleClass="w-[3.3rem]"
                   inputStyleClass="w-[3.3rem]" size="large"/>
    <i class="pi pi-plus clickable" (click)="stepLineWidth(1)"></i>
  </div>
  <div class="row-start-1 row-end-1 col-start-9 col-end-11 text-center">
    {{ 'Toolbar.CircleRadius'|translate }}
  </div>
  <div class="row-start-3 row-end-5 col-start-9 col-end-11  flex justify-around items-center">
    <i class="pi pi-minus clickable" (click)="stepCircleRadius(-5)"></i>
    <p-inputnumber mode="decimal" [(ngModel)]="circleRadius" size="large" class="w-[3.3rem]" styleClass="w-[3.3rem]"
                   inputStyleClass="w-[3.3rem]"/>
    <i class="pi pi-plus clickable" (click)="stepCircleRadius(5)"></i>
  </div>
  <div class="row-start-1 row-end-5 col-start-11 col-end-11 grid grid-cols-2 grid-rows-2 gap-x-2">
    <div class="row-start-1 row-end-1 col-start-1 col-end-1 text-center">
      {{ 'Toolbar.Undo'|translate }}
    </div>
    <div class="row-start-2 row-end-2 col-start-1 col-end-1 flex justify-center">
      <button pButton icon="pi pi-undo" (click)="triggerUndo.emit()" size="large"  [disabled]="historyIndex()<1"></button>
    </div>
    <div class="row-start-1 row-end-1 col-start-2 col-end-2 text-center">
      {{ 'Toolbar.Redo'|translate }}
    </div>
    <div class="row-start-2 row-end-2 col-start-2 col-end-2 flex justify-center">
      <button pButton class="scale-x-[-1]" icon="pi pi-undo" (click)="triggerRedo.emit()" size="large" [disabled]="historyIndex() >= canvasHistoryLength() - 1"></button>
    </div>
  </div>
  <div class="row-start-1 row-end-1 col-start-12 col-end-12 text-center">
    {{ 'Toolbar.Save'|translate }}
  </div>
  <div class="row-start-3 row-end-5 col-start-12 col-end-12 flex justify-center">
    <p-button (onClick)="save()" icon="pi pi-save" size="large"></p-button>
  </div>

</div>
